// extracted by mini-css-extract-plugin
module.exports = {"headerBackground":"styles_headerBackground__1q73m","wrapper":"styles_wrapper__7v29s","header":"styles_header__CoRPB","headerMainItems":"styles_headerMainItems__1szYg"};